import gql from "graphql-tag";


export const getHomeBanner = gql`
{
  pages(first: 10,query:"Home Banner") {
   edges {
     node {
       id
       title
       body
       metafields(first: 10) {
         edges {
           node {
             key
             value
           }
         }
       }
     }
   }
 }
}
`

export const getCollections = gql`
{
  collections(first: 10, query: "title:Home Page") {
    edges {
      node {
        id
        title
        products(first: 10) {
          edges {
            node {
              id
              title
              featuredImage {
                url
              }
              description
              ali1688: metafield(namespace: "1688", key: "fields") {
                id
                createdAt
                value
              }
              priceRange {
                minVariantPrice {
                  amount
                }
                maxVariantPrice {
                  amount
                }
              }
              metafields(first: 10) {
                edges {
                  node {
                    key
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`
